import { useEffect, useRef } from "react";
import jsQR from "jsqr";

const JsQrCameraScanner = ({ setData, invertImage }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    let animationFrameId;

    useEffect(() => {
        const startCamera = async () => {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" },
            });

            videoRef.current.srcObject = stream;
            videoRef.current.setAttribute("playsinline", true);
            await videoRef.current.play();

            scan();
        };

        const scan = () => {
            if (!videoRef.current) return;

            const video = videoRef.current;
            const canvas = canvasRef.current;
            const ctx = canvas.getContext("2d");

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

            let code = jsQR(imageData.data, imageData.width, imageData.height);

            // Try inverted image (helps colored QRs)
            if (!code) {
                invertImage(imageData);
                code = jsQR(imageData.data, imageData.width, imageData.height);
            }

            if (code) {
                setData(code.data);
                stopCamera();
                return;
            }

            animationFrameId = requestAnimationFrame(scan);
        };

        const stopCamera = () => {
            if (animationFrameId) cancelAnimationFrame(animationFrameId);
            const stream = videoRef.current?.srcObject;
            stream?.getTracks().forEach(track => track.stop());
        };

        startCamera();

        return () => stopCamera();
    }, [setData]);

    return (
        <>
            <video ref={videoRef} style={{ width: "100%" }} />
            <canvas ref={canvasRef} style={{ display: "none" }} />
        </>
    );
};

export default JsQrCameraScanner;
